import { RequestBuilder } from "../requestBuilder";
import { UserFocusedGrantsResponseSchema } from "./grantsClient.types";

// Request configuration for the user-focused-grants endpoint
export const UserFocusedGrantsRequestConfig = new RequestBuilder({
  path: () => "/user-focused-grants",
  responseSchema: UserFocusedGrantsResponseSchema,
});
